import { render, staticRenderFns } from "./WidgetsDropdown.vue?vue&type=template&id=338c5807&scoped=true"
import script from "./WidgetsDropdown.vue?vue&type=script&lang=js"
export * from "./WidgetsDropdown.vue?vue&type=script&lang=js"
import style0 from "./WidgetsDropdown.vue?vue&type=style&index=0&id=338c5807&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c5807",
  null
  
)

export default component.exports